<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Hobo Data
      </h2>
      <p class="tw-italic tw-text-gray-700">
        View HOBO Data by Location/Month/Year!
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col></b-col>
        <b-col cols="auto">
          <b-form-select v-model="location" :options="locations"></b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-form-select v-model="month" :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"></b-form-select>
          <!-- <b-form-input v-model="month" placeholder="00"></b-form-input> -->
        </b-col>
        <b-col cols="auto">
          <b-form-select v-model="year" :options="[2019, 2020, 2021, 2022, 2023, 2024, 2025]"></b-form-select>
          <!-- <b-form-input v-model="year" placeholder="0000"></b-form-input> -->
        </b-col>
        <b-col cols="auto">
          <b-button @click="find()" variant="success" class="px-5">Filter</b-button>
        </b-col>
        <b-col cols="auto">
          <b-button :to="{name: 'hobo-upload'}" variant="secondary" class="px-5">Upload</b-button>
        </b-col>
      </b-row>
    </b-container>

    <hr>

    <div ref="temperatureChart" class="tw-overflow-x-scroll">
      <bar-chart
        v-if="loaded"
        :chartData="temperatureChart.chartdata"
        :options="temperatureChart.options"
        :styles="temperatureChart.myStyles"
      >
      </bar-chart>
    </div>

    <div ref="humidityChart" class="tw-overflow-x-scroll">
      <bar-chart
        v-if="loaded"
        :chartData="humidityChart.chartdata"
        :options="humidityChart.options"
        :styles="humidityChart.myStyles"
      >
      </bar-chart>
    </div>

    <div ref="intensityChart" class="tw-overflow-x-scroll">
      <bar-chart
        v-if="loaded"
        :chartData="intensityChart.chartdata"
        :options="intensityChart.options"
        :styles="intensityChart.myStyles"
      >
      </bar-chart>
    </div>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import BarChart from "@/components/charts/BarChart.vue";

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    BarChart
  },
  data() {
    return {
      loaded: false,
      hoboData: {
        chartdata: {
          datasets: [],
          labels: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: "Temperature Readings",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  parser: 'YYYY-MM-DDTHH:mm',
                  tooltipFormat: 'll hh:mm A'
                },
                scaleLabel: {
                  display: true,
                  labelString: "Date",
                },
              },
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Temperature",
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        myStyles: {
          height: "25vh",
          width: "150vh",
          position: "relative",
        },
      },
      temperatureChart: {},
      humidityChart: {},
      intensityChart: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      location: null,
      locations: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.findLocations();
  },
  methods: {
    findLocations() {
      const that = this;
      HTTP.get("/kenya/hobo-locations").then(response => {
        that.locations = response.data;
        that.location = that.locations[0];
        that.find();
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    find() {
      const that = this;

      let temperatureThreshold = 31;
      let humidityThreshold = 75;
      let intensityThreshold = 16;

      let labels = [];
      let datasets = [
        {
          type: "line",
          backgroundColor: "red",
          borderColor: "red",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Threshold",
          data: [],
        },
        {
          type: "line",
          backgroundColor: "orange",
          borderColor: "orange",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Temp, C",
          data: [],
        },
        {
          type: "line",
          backgroundColor: "red",
          borderColor: "red",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Threshold",
          data: [],
        },
        {
          type: "line",
          backgroundColor: "orange",
          borderColor: "orange",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "RH, %",
          data: [],
        },
        {
          type: "line",
          backgroundColor: "red",
          borderColor: "red",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Threshold",
          data: [],
        },
        {
          type: "line",
          backgroundColor: "orange",
          borderColor: "orange",
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          label: "Intensity, lum/ft",
          data: [],
        },
      ];

      HTTP.get("/kenya/hobo-data", {
        params: {
          year: that.year,
          month: that.month,
          location: that.location
        }
      }).then(response => {
          _.each(response.data, (item) => {
            labels.push(item.timestamp);
            datasets[0].data.push(temperatureThreshold);
            datasets[1].data.push(item.temperature);
            datasets[2].data.push(humidityThreshold);
            datasets[3].data.push(item.rh);
            datasets[4].data.push(intensityThreshold);
            datasets[5].data.push(item.intensity);
          });

          that.temperatureChart = _.merge({}, that.hoboData);
          that.humidityChart = _.merge({}, that.hoboData);
          that.intensityChart = _.merge({}, that.hoboData);

          that.temperatureChart.chartdata.labels = labels;
          that.temperatureChart.chartdata.datasets = [datasets[0], datasets[1]];

          that.humidityChart.options.title.text = 'Humidity';
          that.humidityChart.options.scales.yAxes[0].scaleLabel.labelString = '%';
          that.humidityChart.chartdata.labels = labels;
          that.humidityChart.chartdata.datasets = [datasets[2], datasets[3]];

          that.intensityChart.options.title.text = 'Intensity';
          that.intensityChart.options.scales.yAxes[0].scaleLabel.labelString = 'lum/ft';
          that.intensityChart.chartdata.labels = labels;
          that.intensityChart.chartdata.datasets = [datasets[4], datasets[5]];

          that.loaded = true;

          setTimeout(function() {
            that.$refs['temperatureChart'].scrollLeft = that.$refs['temperatureChart'].scrollWidth / 6;
            that.$refs['humidityChart'].scrollLeft = that.$refs['humidityChart'].scrollWidth / 6;
            that.$refs['intensityChart'].scrollLeft = that.$refs['intensityChart'].scrollWidth / 6;
          }, 500);
        }).catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
  },
};
</script>

<style></style>
